import React from "react";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import paths from "@icarius-router/paths";
import CommonPage from "@icarius-common/commonPage";
import { getLocalizedString } from "@icarius-localization/strings";
import { useLocation } from "react-router-dom";
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AssistantIcon from '@material-ui/icons/Assistant';
import SyncIcon from '@material-ui/icons/Sync';
import BotAssistant from "@icarius-common/botAssistant/components";
import useBotAssistant from "@icarius-common/botAssistant/components/useBotAssistant";
import UploadFilesDialog from "./uploadFilesDialog/index";
import useDigitalWarehouse from "./useDigitalWarehouse";

const DigitalWarehouse = ({ history }) => {

  const location = useLocation();
  const groupCode = location.search.substring(location.search.indexOf('=') + 1);

  const {
    data,
    isLoading,
    botAssistantEnabled,
    hasBotAssistant,
    state,
    handlers,
  } = useDigitalWarehouse(groupCode);

  const {
    conversationId,
    conversationIsAssistantLoading,
    selectedConversationMessages,
    handleOpenBotAssistant,
    handleCloseBotAssistant,
    handleSubmitMessage,
    handleCancelSubmitMessage,
    handleResetConversation,
  } = useBotAssistant();

  const dataTreeButton = (gridRef) => (
    <CustomIconButton
      title={state.treeViewIsOpen ? getLocalizedString("viewAsList") : getLocalizedString("viewAsTree")}
      onClick={() => handlers.handleGrouping(gridRef)}
    >
      <AccountTreeIcon />
    </CustomIconButton>
  )

  const previewButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("preview")}
      onClick={() => handlers.handlePreview(gridRef)}
      type={"preview"}
    />
  )

  const createButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("create")}
      onClick={() => handlers.handleOpenCreateDialog(gridRef)}
      type={"add"}
    />
  )

  const modifyButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("edit")}
      onClick={() => handlers.handleOpenEditDialog(gridRef)}
      type={"edit"}
    />
  )

  const deleteButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("delete")}
      onClick={() => handlers.handleOpenDeleteDialog(gridRef)}
      type={"delete"}
    />
  )

  const downloadButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("download")}
      onClick={() => handlers.handleDownload(gridRef)}
      type={"download"}
    />
  )

  const assistantButton = () => botAssistantEnabled && hasBotAssistant && (
    <CustomIconButton
      title={getLocalizedString("icariusAssistant")}
      onClick={() => handleOpenBotAssistant(groupCode || "")}
    >
      <AssistantIcon />
    </CustomIconButton>
  )

  const syncButton = (gridRef) => botAssistantEnabled && hasBotAssistant && (
    <CustomIconButton
      title={getLocalizedString("syncFiles")}
      onClick={() => handlers.handleOpenSyncDialog(gridRef)}
    >
      <SyncIcon />
    </CustomIconButton>
  )

  const goBackButton = () => (
    groupCode &&
    <CustomIconButton
      title={getLocalizedString("goBack")}
      onClick={() => history.push(paths.myGroups)}
      type={"goBack"}
    />
  )

  const getTitle = () => {
    if (!groupCode) return getLocalizedString("myDigitalWarehouse");
    if (location?.state?.name) return `${getLocalizedString("groupDigitalWarehouse")}: ${location.state.name}`;
    return getLocalizedString("digitalWarehouse");
  }

  return (
    <CommonPage
      isLoading={isLoading}
      title={getTitle()}
      gridTitle={getTitle()}
      columnDefPage={groupCode ? paths.digitalWarehouse : paths.myDigitalWarehouse}
      rowData={data}
      menuItems={[goBackButton, createButton, modifyButton, dataTreeButton, previewButton, downloadButton, syncButton, assistantButton, deleteButton]}
      hasExpand
      hasHelp
    >
      <BotAssistant
        key={conversationId}
        open={conversationId !== null}
        isLoading={conversationIsAssistantLoading}
        messages={selectedConversationMessages}
        handleSubmit={handleSubmitMessage}
        handleCancelSubmit={handleCancelSubmitMessage}
        handleResetConversation={handleResetConversation}
        handleClose={handleCloseBotAssistant}
      />
      {
        (state.createDialogIsOpen || state.editDialogIsOpen) &&
        <UploadFilesDialog
          open={(state.createDialogIsOpen || state.editDialogIsOpen)}
          isEdit={state.editDialogIsOpen}
          isLoading={isLoading}
          data={state.selectedDocument}
          groupCode={groupCode}
          handleClose={handlers.handleCloseCreateEditDialog}
        />
      }
    </CommonPage>
  )
}

export default DigitalWarehouse;